import { render, staticRenderFns } from "./PolicyCardPension.vue?vue&type=template&id=79fb7c0f&"
import script from "./PolicyCardPension.vue?vue&type=script&lang=ts&"
export * from "./PolicyCardPension.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports